import React, { ComponentProps, FC, ReactNode } from 'react';
import { StatusFieldOption, TaskType } from 'api/tasks';
import { StatusPickerContext } from 'components/atoms/status-picker/context';
import {
  ActionPanel,
  usePopoverActionRef,
} from 'components/molecules/action-panel';
import { useTranslation } from 'hooks/use-translation';
import { StatusField, TaskField } from 'stores/fields';
import { FieldHelper } from 'utils/field';
import { OnChange } from '../bulk-editor';
import { Popover, StatusPicker } from './components';

const {
  PopoverAction,
  Popover: { Title },
} = ActionPanel;

type Props = {
  status: StatusField;
  title: ReactNode;
  allowed: ComponentProps<typeof PopoverAction>['allowed'];
  onChange: OnChange;
  innerRef?: ReturnType<typeof usePopoverActionRef>;
};

export const SetStatus: FC<Props> = ({
  title,
  status,
  allowed,
  onChange,
  innerRef,
}) => {
  const taskStatusHeader = useTranslation('task_status');
  const {
    options: { activeOptions },
  } = FieldHelper(status);

  return (
    <PopoverAction ref={innerRef} title={title} allowed={allowed}>
      <Popover>
        <Title>{title}</Title>
        <StatusPickerContext.Provider
          value={{ type: TaskType.Task, isOpen: true }}
        >
          <StatusPicker
            header={taskStatusHeader}
            options={activeOptions as StatusFieldOption[]}
            value={null as unknown as StatusFieldOption}
            onChange={(latest: StatusFieldOption) =>
              onChange(status as TaskField, latest?.value ?? null)
            }
          />
        </StatusPickerContext.Provider>
      </Popover>
    </PopoverAction>
  );
};
